import Contacts from '../../../store/contacts';

angular
    .module('festzelt-os.modules.contacts')
    .factory('Contacts', [
        '$injector',
        'Contact',
        ($injector, Contact) => new Contacts(Contact, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/contacts/store/contacts.js